import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import PhoneNumberInput from "components/PhoneNumberInput";
import { useMutation } from "@apollo/client";
import { CHANGE_CONTACT } from "graphql/service";
import { Head, Container, Footer } from "./styles";
import ModalVerification from "screens/ModalVerification";

const ModalNewPhoneNumber = ({
  hidden,
  isOpen,
  setIsOpen,
  refetch,
  token
}) => {

  const [verificationIsOpen, setVerificationIsOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("")
  const [phoneNumberValidity, setPhoneNumberValidity] = useState(true);
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [changeContact, { loading }] = useMutation(CHANGE_CONTACT, {
    onCompleted: (data) => {
      setIsOpen(false);
      setVerificationIsOpen(true);
      setPhoneNumberError(false);
    },
    onError: (error) => {
      setPhoneNumberError(true);
      let messages = [];

      if (error.graphQLErrors?.length > 0) {
        messages = error.graphQLErrors.map(err => err.message);
      } else if (error.networkError?.result?.errors) {
        messages = error.networkError.result.errors.map(err => err.message);
      } else if (error.networkError) {
        messages = [error.networkError.message];
      }

      if (messages?.length > 0) {
        setErrorMessage(messages.join(", "));
      }
    }
  });

  const handleContinue = () => {
    if (!(phoneNumberValidity && phoneNumber.length > 0)) {
      setPhoneNumberError(true);
      setErrorMessage("Please enter a valid phone number.");
      return;
    }
    changeContact({
      variables: {
        input: {
          contactType: "PHONE",
          sessionToken: token,
          newValue: phoneNumber
        }
      }
    });
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        setClose={() => {
          setIsOpen(false);
          setPhoneNumber("");
          setPhoneNumberError(false);
          setPhoneNumberValidity(true);
          setErrorMessage("");
        }}
        className="modal-success"
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>
          Enter New Phone Number
        </Head>
        <Container>
          <PhoneNumberInput
            title="PHONE NUMBER"
            required
            error={phoneNumberError}
            errorMessage={errorMessage}
            value={phoneNumber}
            onChangeNumber={(number) => {
              setPhoneNumberError(false);
              setPhoneNumber(number);
            }}
            onPhoneValidityChange={setPhoneNumberValidity}
            onBlur={() => {          
              setPhoneNumberError(!phoneNumberValidity && phoneNumber.length > 0);
            }}
          />
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 97px;
            `}
            onMouseDown={(e) => e.preventDefault()}
            onClick={handleContinue}
            data-loading={loading}
          >
            {loading ? null : "Continue"}
          </Button>
        </Footer>
      </MainModal>
      <ModalVerification
        isOpen={verificationIsOpen}
        setClose={() => {
          setVerificationIsOpen(false);
          setPhoneNumber("");
        }}
        refetch={refetch}
        token={token}
        phoneNumber={phoneNumber}
      />
    </>
  );
};

export default ModalNewPhoneNumber;